<template lang="pug">
  .action-rank
    SectionHeader(:header="header")

    .action__body
      .action__section
        .action__grid
          .action__form-field(v-for="(item, i) of items" :key="i")
            InputSmart(:item="item")

      .action__bottom
        Button(is-primary @click="onCheckButtonClick") Изменить

</template>

<script>
import { mapActions, mapState } from 'vuex'
import InputSmart from '@/components/InputSmart/InputSmart'
import SectionHeader from '@/components/SectionHeader/SectionHeader'

export default {
  name: 'ActionRank',

  components: {
    InputSmart,
    SectionHeader,
  },

  data: () => ({
    items: {
      id: {
        title: 'ID игрока',
        value: null,
        type: 'number',
        placeholder: 'Введите ID',
      },

      rating: {
        title: 'Рейтинг',
        value: null,
        type: 'number',
        placeholder: 'Внутренний рейтинг VVV',
      },
    }
  }),

  computed: {
    ...mapState('games', ['gamesByName']),

    gameName() {
      return this.$route.params.section
    },

    header() {
      return {
        title: `${this.$gameNameText(this.gameName)} / Изменение рейтинга игрока`,
        game: this.gameName,
      }
    },
  },

  created() {
    this.$forceUpdate()
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    async onCheckButtonClick() {
      this.$loading.start()

      try {
        const playerId = this.items.id.value
        const rating = this.items.rating.value

        const { data } = await this.$axios.put(`/admin/games/${this.gameName}/user/${playerId}/rating`, {
          rating,
        })

        if (data.data) {
          this.showModal({
            component: 'ModalMessage',
            data: {
              type: 'success',
              title: 'Успех',
              text: 'Рейтинг изменён!',
            },
          })
        }
      } catch (e) {
        this.$error.handle(e)
      }

      this.$loading.finish()
    }
  },
}
</script>

<style lang="scss">
</style>
